import { getContragents, getEmployees, getTeamMastersByGroup } from "../api";
import {
  setModuleContragents,
  setRoles,
} from "../../../redux/reducers/appReducer";
import { getRolesData } from "../../ManageAccess/ManageAccessSelect/services";
import { Employee, Master } from "../../../types";
import { PaginationType } from "../../ManageAccess/types";

type EmployeesDataResult = {
  employees: Employee[];
  pagination: PaginationType | null;
};

export const getEmployeesData = async (
  params,
  setIsFetching,
): Promise<EmployeesDataResult> => {
  try {
    setIsFetching(true);
    const { employees, pagination } = await getEmployees(params);
    setIsFetching(false);
    return { employees: employees || [], pagination: pagination || null };
  } catch (e) {
    setIsFetching(false);
    return { employees: [], pagination: null };
  }
};

export const getAllRolesData = () => async (dispatch) => {
  const groups = await getRolesData();
  dispatch(setRoles(groups));
};

export const refactorContragentsList = (contragents) => {
  if (!contragents) return [];
  const contragentsList = [];

  contragents?.forEach((contragent) => {
    const { contragent_name, contragent_id } = contragent;
    contragentsList.push({ contragent_name, contragent_id });
    if (!!contragent.sub_contragents?.length) {
      contragent?.sub_contragents?.forEach((sub) => {
        const { contragent_name, contragent_id } = sub;
        contragentsList.push({ contragent_name, contragent_id, is_sub: true });
      });
    }
  });
  return contragentsList;
};

export const getContragentsData = () => async (dispatch) => {
  try {
    const { contragents: contragentsList } = await getContragents();
    const contragents = refactorContragentsList(contragentsList);
    dispatch(setModuleContragents(contragents));
  } catch (e) {
    dispatch(setModuleContragents([]));
  }
};
export const getTeamMastersByGroupData = async (
  group_code: string,
): Promise<Master[]> => {
  try {
    const res = await getTeamMastersByGroup(group_code);
    return res?.team_masters;
  } catch (e) {}
};
